import request from "@/utils/request";

export function getCustomerSentence() {
  return request({
    url: "/shortcut/list",
    method: "get",
    params: {
      type: "customer"
    }
  });
}

export function getServiceSentence() {
  return request({
    url: "/shortcut/list",
    method: "get",
    params: {
      type: "boss"
    }
  });
}
